import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { alertService } from '../../services/helpers/alert.service';
import { searchService } from "../../services/api/search.service";
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";


export const SearchMMRecords = (props) => {

    const { partener, deladata, ladata, cnp, status_finalizare, status_aprobare, numePacient, companie, emisDe } = props.params;
    const [lista, setLista] = useState(null);
    const navigate = useNavigate();

    const params = {
        partner: partener?.id,
        datastart: deladata ? utils.convertDate(deladata) : "",
        dataend: ladata ? utils.convertDate(ladata) : "",
        cnp: cnp,
        statusfinalizare: status_finalizare.id ?? 0,
        statusaprobare: status_aprobare.id ?? 0,
        numepacient: numePacient ?? "",
        companie: companie ?? "",
        emisde: emisDe != null ?  emisDe.id : 0
    }

    useEffect(() => {

        if (utils.checkEmptyProperties(props.params)) {
            alertService.error("Trebuie sa completezi macar un parametru!");
        }
        else {

            searchService.getMMRecords(params).then(response => {
                if (response) {
                    setLista(response);
                }
                else {
                    setLista(null);
                }
            });
        }
    }, [props.params]);

    const handleView = (page, param, value) => {

        var encode = {
            displayValue: props.params,
            activeComponent: props.activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }

    const handleExport = () => {
        reportService.RaportCautareFiseMM({
            cnp: params.cnp,
            deLaData: params.datastart,
            laData: params.dataend,
            statusFinalizare: params.statusfinalizare,
            partener: params.partner,
            nume: params.numepacient,
            companie: params.companie,
            emisde: params.emisde
        }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }



    return (
        <>
            {lista &&
                <>
                    <p className="paragraf">Fise MM:</p>
                    <table className="tbl" name="lista" width="100%">
                        <thead>
                            <tr>
                                <th className="first">Nr</th>
                                <th>Pacient</th>
                                <th>CNP</th>
                                <th>Cod</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Tip fisa</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Finalizat la</th>
                                <th>Data emitere</th>
                                <th>ID</th>
                                <th>Emis de</th>
                                <th className="tac">Vezi fisa</th>
                            </tr>
                        </thead>
                        <tbody>
                        {lista.map((row, index) => (
                            <tr key={index}>
                                <td name="nr_crt" className="center first">{index + 1}</td>
                                <td name="nume_pacient"> {row.pacient}</td>
                                <td name="cnp" className="center"> {row.cnp}</td>
                                <td name="cod_pacient" className="center"> {row.codPacient}</td>
                                <td name="nume_firma"> {row.companie}</td>
                                <td name="nume_profil">
                                    {row.abonament}
                                    {row.firmaMaster && <span> (</span>}
                                    {row.firmaMaster}
                                    {row.firmaMaster && <span>)</span>}
                                </td>
                                <td name="tip_fisa">{row.tipFisa}</td>
                                <td name="status" className="center">{row.status}</td>
                                <td name="dataora_inregistrare" className="center">{ row.adaugatLa}</td>

                                <td name="partener" className="center"> {row.partener}</td>
                                <td name="data_emitere" className="center">{row.dataEmitere ?? ""}</td>
                                <td className="center"> {row.idFisa}</td>
                                <td className="center"> {row.emisDe}</td>
                                <td>
                                    <a className="icon deschide m0auto"
                                        onClick={() => handleView("fisa-mm", "id", row.idFisa)}
                                        title="Vezi Fisa"
                                        name="view">Vizualizare</a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div name="export">
                       <button name="btn-export" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};

